import { useState, useEffect } from 'react';
import supabase from '../supabase/supabase';

export const useArtist = (slug) => {
  const [artist, setArtist] = useState(null);
  const [releases, setReleases] = useState([]);
  const [exclusiveContent, setExclusiveContent] = useState([]);
  const [patrons, setPatrons] = useState([]);
  const [tiers, setTiers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;
    fetchArtistData();
  }, [slug]);

  const fetchArtistData = async () => {
    try {
      setLoading(true);
      setError(null);

      const { data: artistData, error: artistErr } = await supabase
        .from('d2f_artists')
        .select('*')
        .eq('slug', slug)
        .maybeSingle();

      if (artistErr) throw artistErr;
      if (!artistData) throw new Error('Artist not found');
      setArtist(artistData);

      const [releasesRes, contentRes, patronsRes, tiersRes] = await Promise.all([
        supabase
          .from('d2f_releases')
          .select('*')
          .eq('artist_id', artistData.id)
          .order('release_date', { ascending: false }),
        supabase
          .from('d2f_exclusive_content')
          .select('*')
          .eq('artist_id', artistData.id)
          .order('created_at', { ascending: false }),
        supabase
          .from('d2f_patrons')
          .select('id, total_contributed, d2f_profiles(display_name, avatar_url, username)')
          .eq('artist_id', artistData.id)
          .order('total_contributed', { ascending: false })
          .limit(5),
        supabase
          .from('d2f_subscription_tiers')
          .select('*')
          .eq('artist_id', artistData.id)
          .order('price', { ascending: true })
      ]);

      setReleases(releasesRes.data || []);
      setExclusiveContent(contentRes.data || []);
      setPatrons(patronsRes.data || []);
      setTiers(tiersRes.data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { artist, releases, exclusiveContent, patrons, tiers, loading, error, refetch: fetchArtistData };
};